export const TRANSLATIONS_ROOT_KEY = 'fe';

export const TRANSLATIONS_REQUIRED_FIELD_KEY = `${TRANSLATIONS_ROOT_KEY}.form.required`;
export const TRANSLATIONS_EMAIL_FIELD_KEY = `${TRANSLATIONS_ROOT_KEY}.form.email`;

export const TRANSLATIONS_BUTTONS_KEY = `${TRANSLATIONS_ROOT_KEY}.button`;
export const TRANSLATIONS_REGISTER_KEY = `${TRANSLATIONS_ROOT_KEY}.register`;
export const TRANSLATIONS_FORGOTTEN_PASS_KEY = `${TRANSLATIONS_ROOT_KEY}.forgotten-password`;
export const TRANSLATIONS_USERS_KEY = `${TRANSLATIONS_ROOT_KEY}.users`;
